export const styles = {
	container: {
		width: '100%',
		px: { xs: 2, sm: 8, md: 12 },
		py: { xs: 2, sm: 4 },
		boxSizing: 'border-box',
	},
	helpText: {
		mb: 3,
	},
	helpTextSpan: {
		fontSize: 16,
	},
	requestButton: {
		width: { xs: '100%', sm: 'auto' },
		border: '1.5px solid #5B6B7A',
		borderRadius: '4px',
		background: '#fff',
		color: '#5B6B7A',
		fontWeight: 'bold',
		fontSize: { xs: 15, sm: 16 },
		px: { xs: 0, sm: 2 },
		py: 1.5,
		mt: 0.5,
		cursor: 'pointer',
		transition: 'background 0.2s',
		textDecoration: 'none',
		display: 'inline-block',
		'&:hover': {
			background: '#f5f7fa',
		},
	},
	accordionContainer: {
		mt: 6,
		backgroundColor: '#fff',
	},
	// Header text box (above search bar)
	headerTextBox: {
		mb: 1,
		mt: 4,
	},
	headerTextSpan: {
		fontSize: 18,
		fontWeight: 400,
	},
	// Search bar container
	searchBarContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: { xs: 'stretch', sm: 'center' },
		gap: { xs: 2, sm: 2 },
		mb: 4,
		py: 1,
		width: '100%',
		maxWidth: '100%',
	},
	searchInput: (hasValue: boolean) => ({
		width: '80%',
		flex: 'none',
		height: 46,
		border: hasValue ? '1px solid #808080' : '1px solid #ccc',
		borderRadius: '6px',
		px: 2,
		fontSize: { xs: 15, sm: 16 },
		background: '#fff',
		mb: { xs: 1, sm: 0 },
		boxSizing: 'border-box',
		'::placeholder': {
			color: '#b0b0b0',
			opacity: 1,
		},
	}),
	askButton: {
		width: { xs: '100%', sm: 'auto' },
		height: 46,
		px: { xs: 0, sm: 3 },
		borderRadius: '6px',
		border: '1px solid #ccc',
		fontWeight: 600,
		fontSize: 14,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 1,
		'&:not(:disabled)': {
			background: '#5B6B7A',
			color: '#fff',
			cursor: 'pointer',
			border: '1px solid #5B6B7A',
			'&:hover': {
				background: '#4a5a69',
			},
		},
		'&:disabled': {
			background: '#f5f5f5',
			color: '#888',
			cursor: 'default',
		},
	},
	askButtonDisabled: {
		width: { xs: '100%', sm: 'auto' },
		height: 46,
		px: { xs: 0, sm: 3 },
		borderRadius: '6px',
		border: '1px solid #ccc',
		background: '#f5f5f5',
		color: '#888',
		fontWeight: 600,
		fontSize: 14,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 1,
		cursor: 'default',
	},
	askButtonActive: {
		width: { xs: '100%', sm: 'auto' },
		height: 46,
		px: { xs: 0, sm: 3 },
		borderRadius: '6px',
		border: 'none',
		background: '#45657B',
		color: '#FFFFFF',
		fontWeight: 600,
		fontSize: 14,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 1,
		cursor: 'pointer',
		transition: 'background 0.2s ease',
		'&:hover': {
			background: '#274A62',
		},
	},
	askButtonIconSpan: {
		display: 'flex',
		alignItems: 'center',
		marginRight: 0,
	},
	aiResponseContainer: {
		mb: 4,
	},
}
